import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import router from '@/router'
import { useAppStore } from '@/stores/app'

export const useFetchStore = defineStore('fetch', () => {
    const appStore = useAppStore()

    const fetch = createFetch({
        baseUrl: '/api/nmr-api/v1',
        options: {
            beforeFetch({ options }) {
                options.headers = new Headers(options.headers)
                options.headers.set('Authorization', `Bearer ${appStore.getJWT()}`)
                return { options }
            },
            async onFetchError(ctx) {
                if (ctx.response?.status === 401) {
                    appStore.setLogout()
                    await router.push({ name: 'login' })
                }
                return ctx
            },
        },
    })

    return { fetch }
})
